/**
 * Filters integrations using the filters passed as parameter
 *
 * @param {Array} filters The filters. An array of functions used for filtering
 * @return {Object} The integrations
 */
const filterIntegrations = ( filters = [] ) => {
	// Iterate all integrations, an apply the filters
	const integrations = Object.entries( UncannyAutomator._integrations ).filter( (
		[ integrationID, integration ]
	) => {
		// Iterate filters
		return filters.every( filter => filter( integration ) );
	} );

	return Object.fromEntries( integrations );
}

export default filterIntegrations;
